import { render, staticRenderFns } from "./BundleAssignDriverDialog.vue?vue&type=template&id=243b9f20"
import script from "./BundleAssignDriverDialog.vue?vue&type=script&lang=js"
export * from "./BundleAssignDriverDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports